/* Forzono — Find your diamond size (no dependencies).
   Everything is drawn in millimetres: a stone and the finger it sits on keep their true proportions.
   Face-up sizes are typical for well-cut stones; 1 ct round ≈ 6.5 mm and size scales with the cube root of weight. */
(function () {
  'use strict';
  if (window.__fzDiamondSize) return;
  window.__fzDiamondSize = true;

  var NS = 'http://www.w3.org/2000/svg';
  // typical face-up length × width (mm) at 1.00 ct; length runs along the finger
  var SHAPES = {
    round: { L: 6.5, W: 6.5, cut: 'brilliant' },
    oval: { L: 7.7, W: 5.7, cut: 'brilliant' },
    emerald: { L: 7.0, W: 5.0, cut: 'step' },
    pear: { L: 8.5, W: 5.5, cut: 'brilliant' },
    cushion: { L: 6.0, W: 5.5, cut: 'brilliant' },
    princess: { L: 5.5, W: 5.5, cut: 'brilliant' },
    radiant: { L: 6.5, W: 5.2, cut: 'brilliant' },
    marquise: { L: 10.0, W: 5.0, cut: 'brilliant' },
    asscher: { L: 5.5, W: 5.5, cut: 'step' },
    heart: { L: 6.5, W: 6.5, cut: 'brilliant' }
  };
  var ORDER = ['round', 'oval', 'emerald', 'pear', 'cushion', 'princess', 'radiant', 'marquise', 'asscher', 'heart'];
  // US ring size → inside diameter (mm)
  var RING = { 4: 14.9, 5: 15.7, 6: 16.5, 7: 17.3, 8: 18.1, 9: 19.0, 10: 19.8 };
  var METALS = {
    yellow: ['#f0d58e', '#c99a45', '#a9792c'],
    white: ['#f6f7f9', '#c9ccd3', '#9a9ea8'],
    rose: ['#f3c3ad', '#d28f74', '#b2705a']
  };
  var COMPARE = [0.5, 1, 1.5, 2, 3];

  function dims(shape, ct) {
    var d = SHAPES[shape] || SHAPES.round, k = Math.cbrt(ct);
    return { L: d.L * k, W: d.W * k };
  }
  function f(n) { return (Math.round(n * 100) / 100).toString(); }

  /* outline path centred on 0,0 — L vertical, W horizontal */
  function outline(shape, L, W) {
    var h = L / 2, w = W / 2, c, r, cy;
    function oct(cx) {
      return 'M' + f(-w + cx) + ',' + f(-h) + 'H' + f(w - cx) + 'L' + f(w) + ',' + f(-h + cx) + 'V' + f(h - cx) + 'L' + f(w - cx) + ',' + f(h) + 'H' + f(-w + cx) + 'L' + f(-w) + ',' + f(h - cx) + 'V' + f(-h + cx) + 'Z';
    }
    switch (shape) {
      case 'round': case 'oval':
        return 'M' + f(-w) + ',0A' + f(w) + ',' + f(h) + ' 0 1 0 ' + f(w) + ',0A' + f(w) + ',' + f(h) + ' 0 1 0 ' + f(-w) + ',0Z';
      case 'princess': return oct(0);
      case 'radiant': return oct(W * 0.12);
      case 'emerald': return oct(W * 0.18);
      case 'asscher': return oct(W * 0.26);
      case 'cushion':
        r = Math.min(L, W) * 0.32;
        return 'M' + f(-w + r) + ',' + f(-h) + 'H' + f(w - r) + 'Q' + f(w) + ',' + f(-h) + ' ' + f(w) + ',' + f(-h + r) + 'V' + f(h - r) + 'Q' + f(w) + ',' + f(h) + ' ' + f(w - r) + ',' + f(h) + 'H' + f(-w + r) + 'Q' + f(-w) + ',' + f(h) + ' ' + f(-w) + ',' + f(h - r) + 'V' + f(-h + r) + 'Q' + f(-w) + ',' + f(-h) + ' ' + f(-w + r) + ',' + f(-h) + 'Z';
      case 'pear':
        r = w; cy = h - r;
        return 'M0,' + f(-h) + 'C' + f(W * 0.2) + ',' + f(-L * 0.3) + ' ' + f(w) + ',' + f(cy - r * 0.95) + ' ' + f(w) + ',' + f(cy) + 'A' + f(r) + ',' + f(r) + ' 0 0 1 ' + f(-w) + ',' + f(cy) + 'C' + f(-w) + ',' + f(cy - r * 0.95) + ' ' + f(-W * 0.2) + ',' + f(-L * 0.3) + ' 0,' + f(-h) + 'Z';
      case 'marquise':
        c = W * 0.667;
        return 'M0,' + f(-h) + 'C' + f(c) + ',' + f(-L * 0.25) + ' ' + f(c) + ',' + f(L * 0.25) + ' 0,' + f(h) + 'C' + f(-c) + ',' + f(L * 0.25) + ' ' + f(-c) + ',' + f(-L * 0.25) + ' 0,' + f(-h) + 'Z';
      case 'heart':
        return 'M0,' + f(h) + 'C' + f(-W * 0.12) + ',' + f(L * 0.36) + ' ' + f(-w) + ',' + f(L * 0.14) + ' ' + f(-w) + ',' + f(-L * 0.16) + 'C' + f(-w) + ',' + f(-L * 0.42) + ' ' + f(-W * 0.18) + ',' + f(-h) + ' 0,' + f(-L * 0.3) + 'C' + f(W * 0.18) + ',' + f(-h) + ' ' + f(w) + ',' + f(-L * 0.42) + ' ' + f(w) + ',' + f(-L * 0.16) + 'C' + f(w) + ',' + f(L * 0.14) + ' ' + f(W * 0.12) + ',' + f(L * 0.36) + ' 0,' + f(h) + 'Z';
    }
    return outline('round', L, W);
  }

  function prongs(shape, L, W) {
    var h = L / 2, w = W / 2, d = 0.7071;
    switch (shape) {
      case 'round': case 'oval': case 'cushion':
        return [[w * d, -h * d], [-w * d, -h * d], [w * d, h * d], [-w * d, h * d]];
      case 'princess': case 'radiant': case 'emerald': case 'asscher':
        return [[w * 0.9, -h * 0.9], [-w * 0.9, -h * 0.9], [w * 0.9, h * 0.9], [-w * 0.9, h * 0.9]];
      case 'pear':
        return [[0, -h * 0.97], [w * 0.92, h * 0.25], [-w * 0.92, h * 0.25], [0, h * 0.98]];
      case 'marquise':
        return [[0, -h * 0.97], [0, h * 0.97], [w * 0.9, 0], [-w * 0.9, 0]];
      case 'heart':
        return [[0, h * 0.95], [w * 0.88, -h * 0.4], [-w * 0.88, -h * 0.4]];
    }
    return [];
  }

  function el(name, attrs, parent) {
    var n = document.createElementNS(NS, name);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }

  var uid = 0;
  /* draws a stone (with facets, optional prongs) into group g at x,y */
  function stone(g, shape, ct, x, y, opts) {
    opts = opts || {};
    var d = dims(shape, ct), L = d.L, W = d.W, id = 'ds' + (++uid);
    var path = outline(shape, L, W);
    var grp = el('g', { transform: 'translate(' + f(x) + ',' + f(y) + ')' }, g);
    var defs = el('defs', {}, grp);
    var rg = el('radialGradient', { id: id + 'g', cx: '42%', cy: '38%', r: '70%' }, defs);
    el('stop', { offset: '0', 'stop-color': '#ffffff' }, rg);
    el('stop', { offset: '.55', 'stop-color': '#eef2f6' }, rg);
    el('stop', { offset: '1', 'stop-color': '#c9d3de' }, rg);
    var cp = el('clipPath', { id: id + 'c' }, defs);
    el('path', { d: path }, cp);
    if (opts.shadow) el('path', { d: path, fill: 'rgba(40,24,12,.28)', transform: 'translate(.35,.55)', filter: 'url(#dsBlur)' }, grp);
    el('path', { d: path, fill: 'url(#' + id + 'g)' }, grp);
    var fac = el('g', { 'clip-path': 'url(#' + id + 'c)', stroke: '#9fb0c2', 'stroke-width': f(Math.max(0.05, W * 0.012)), fill: 'none', opacity: '.85' }, grp);
    var info = SHAPES[shape] || SHAPES.round;
    if (info.cut === 'step') {
      [0.78, 0.56].forEach(function (k) { el('path', { d: outline(shape, L * k, W * k) }, fac); });
      el('path', { d: 'M' + f(-W / 2) + ',' + f(-L / 2) + 'L' + f(-W * 0.28) + ',' + f(-L * 0.28) + 'M' + f(W / 2) + ',' + f(-L / 2) + 'L' + f(W * 0.28) + ',' + f(-L * 0.28) + 'M' + f(-W / 2) + ',' + f(L / 2) + 'L' + f(-W * 0.28) + ',' + f(L * 0.28) + 'M' + f(W / 2) + ',' + f(L / 2) + 'L' + f(W * 0.28) + ',' + f(L * 0.28) }, fac);
    } else {
      el('path', { d: outline(shape, L * 0.52, W * 0.52) }, fac);
      var rays = '';
      for (var i = 0; i < 16; i++) {
        var a = (Math.PI * 2 * i) / 16, cx = Math.cos(a), sy = Math.sin(a);
        rays += 'M' + f(cx * W * 0.26) + ',' + f(sy * L * 0.26) + 'L' + f(cx * W * 0.75) + ',' + f(sy * L * 0.75);
      }
      el('path', { d: rays }, fac);
    }
    el('path', { d: path, fill: 'none', stroke: '#8a9bb0', 'stroke-width': f(Math.max(0.06, W * 0.018)) }, grp);
    el('ellipse', { cx: f(-W * 0.14), cy: f(-L * 0.16), rx: f(W * 0.09), ry: f(L * 0.05), fill: '#fff', opacity: '.9' }, grp);
    if (opts.metal) {
      var m = METALS[opts.metal] || METALS.yellow, pr = Math.max(0.42, W * 0.075);
      prongs(shape, L, W).forEach(function (p) {
        el('circle', { cx: f(p[0]), cy: f(p[1]), r: f(pr), fill: m[1], stroke: m[2], 'stroke-width': '.12' }, grp);
        el('circle', { cx: f(p[0] - pr * 0.3), cy: f(p[1] - pr * 0.3), r: f(pr * 0.35), fill: m[0] }, grp);
      });
    }
    return d;
  }

  function svgRoot(vb, label) {
    var svg = el('svg', { viewBox: vb, role: 'img', 'aria-label': label, preserveAspectRatio: 'xMidYMid meet' });
    var defs = el('defs', {}, svg);
    var fl = el('filter', { id: 'dsBlur', x: '-20%', y: '-20%', width: '140%', height: '140%' }, defs);
    el('feGaussianBlur', { stdDeviation: '.45' }, fl);
    return svg;
  }

  function drawHand(st) {
    var D = RING[st.size] || RING[6], m = METALS[st.metal] || METALS.yellow;
    var svg = svgRoot('-17 -31 34 54', '');
    var defs = svg.querySelector('defs');
    var skin = el('linearGradient', { id: 'dsSkin', x1: '0', x2: '1', y1: '0', y2: '0' }, defs);
    el('stop', { offset: '0', 'stop-color': '#d9a889' }, skin);
    el('stop', { offset: '.35', 'stop-color': '#f0cdb6' }, skin);
    el('stop', { offset: '.7', 'stop-color': '#ebc2a7' }, skin);
    el('stop', { offset: '1', 'stop-color': '#cf9a7b' }, skin);
    var band = el('linearGradient', { id: 'dsBand', x1: '0', x2: '0', y1: '0', y2: '1' }, defs);
    el('stop', { offset: '0', 'stop-color': m[0] }, band);
    el('stop', { offset: '.5', 'stop-color': m[1] }, band);
    el('stop', { offset: '1', 'stop-color': m[2] }, band);
    var r = D / 2;
    // finger: rounded tip at the top, continues off the bottom edge
    el('path', { d: 'M' + f(-r) + ',40V' + f(-30 + r) + 'A' + f(r) + ',' + f(r) + ' 0 0 1 ' + f(r) + ',' + f(-30 + r) + 'V40Z', fill: 'url(#dsSkin)', stroke: '#c48f72', 'stroke-width': '.25' }, svg);
    // nail and knuckle creases
    el('rect', { x: f(-r * 0.62), y: f(-29), width: f(r * 1.24), height: f(D * 0.72), rx: f(r * 0.6), fill: '#f6dccd', stroke: '#d9ae95', 'stroke-width': '.2' }, svg);
    el('path', { d: 'M' + f(-r * 0.45) + ',-10.5Q0,-11.6 ' + f(r * 0.45) + ',-10.5M' + f(-r * 0.35) + ',-9.4Q0,-10.2 ' + f(r * 0.35) + ',-9.4', stroke: '#c9967a', 'stroke-width': '.22', fill: 'none', opacity: '.7' }, svg);
    // band across the finger
    var bandY = 3, bh = 2.3;
    el('rect', { x: f(-r), y: f(bandY - bh / 2), width: f(D), height: f(bh), fill: 'url(#dsBand)' }, svg);
    el('rect', { x: f(-r), y: f(bandY - bh / 2), width: f(D), height: '.35', fill: '#fff', opacity: '.35' }, svg);
    var d = stone(svg, st.shape, st.carat, 0, bandY, { metal: st.metal, shadow: true });
    return { svg: svg, d: d, D: D };
  }

  /* ---------- Photographic mode ----------
     ds-hand.jpg is the 1792 × 2240 photo with 300 px of mirrored linen added each side (2392 wide),
     so wide frames never show past its edge; the ring sits on the ring finger at (1008, 900).
     The finger measures 156 px across there, so 156 px = the chosen ring size's inside diameter.
     The finger leans 3.5° (fingertip to the left); band and stone follow it.
     Two framings: the whole hand (fingertips to wrist) and a close-up of the ring. */
  var HAND = { w: 2392, h: 2240, x: 1008, y: 900, finger: 156, angle: -3.5,
    whole: [630, 60, 1210, 1900], zoom: [688, 580, 640, 640] };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function metalDefs(defs, id) {
    Object.keys(METALS).forEach(function (k) {
      var m = METALS[k];
      // band: cylinder across the finger, dark at both edges, bright just left of centre
      var g = el('linearGradient', { id: id + 'b-' + k, x1: '0', x2: '1', y1: '0', y2: '0' }, defs);
      [[0, m[2]], [0.1, m[1]], [0.32, m[0]], [0.42, '#fffaf0'], [0.55, m[0]], [0.78, m[1]], [0.93, m[2]], [1, m[2]]].forEach(function (s) { el('stop', { offset: s[0], 'stop-color': s[1] }, g); });
      // prong: small polished ball
      var r = el('radialGradient', { id: id + 'p-' + k, cx: '35%', cy: '32%', r: '75%' }, defs);
      [[0, '#fffaf0'], [0.35, m[0]], [0.75, m[1]], [1, m[2]]].forEach(function (s) { el('stop', { offset: s[0], 'stop-color': s[1] }, r); });
    });
  }

  function PhotoScene(photos) {
    var id = 'dsp' + (++uid), h = HAND;
    this.photos = photos; this.id = id; this.vb = h.whole.slice();
    var svg = this.svg = svgRoot(h.whole.join(' '), '');
    svg.setAttribute('class', 'ds__photo');
    var defs = svg.querySelector('defs');
    metalDefs(defs, id);
    var soft = el('filter', { id: id + 's', x: '-50%', y: '-50%', width: '200%', height: '200%' }, defs);
    this.blur = el('feGaussianBlur', { stdDeviation: '4' }, soft);
    el('image', { href: photos.hand, x: '0', y: '0', width: h.w, height: h.h, preserveAspectRatio: 'none' }, svg);
    var g = el('g', { transform: 'translate(' + h.x + ',' + h.y + ') rotate(' + h.angle + ')' }, svg);
    this.bandShadow = el('rect', { fill: 'rgba(60,32,18,.32)', filter: 'url(#' + id + 's)' }, g);
    this.band = el('rect', {}, g);
    // top-to-bottom shading so the band reads as rounded metal, not a flat strip
    var vg = el('linearGradient', { id: id + 'v', x1: '0', x2: '0', y1: '0', y2: '1' }, defs);
    [[0, 'rgba(255,255,255,.35)'], [0.3, 'rgba(255,255,255,0)'], [0.7, 'rgba(0,0,0,0)'], [1, 'rgba(40,24,12,.28)']].forEach(function (s) { el('stop', { offset: s[0], 'stop-color': s[1] }, vg); });
    this.bandRound = el('rect', { fill: 'url(#' + id + 'v)' }, g);
    this.bandLine = el('rect', { fill: '#fff', opacity: '.45' }, g);
    this.stoneShadow = el('path', { fill: 'rgba(50,28,14,.38)', filter: 'url(#' + id + 's)' }, g);
    this.stoneImg = el('image', { preserveAspectRatio: 'none' }, g);
    this.fallback = el('g', {}, g);
    this.prongs = el('g', {}, g);
    this.shape = null;
  }
  PhotoScene.prototype.update = function (st) {
    var D = RING[st.size] || RING[6], s = HAND.finger / D, d = dims(st.shape, st.carat);
    var L = d.L * s, W = d.W * s, id = this.id, metal = METALS[st.metal] ? st.metal : 'yellow';
    // band: 2 mm wide, wraps the finger with ~1.3 mm of metal showing past each edge
    var bt = 2 * s, hw = HAND.finger / 2 + 0.7 * s;
    attrs(this.band, { x: -hw, y: -bt / 2, width: hw * 2, height: bt, rx: bt * 0.32, fill: 'url(#' + id + 'b-' + metal + ')' });
    attrs(this.bandRound, { x: -hw, y: -bt / 2, width: hw * 2, height: bt, rx: bt * 0.32 });
    attrs(this.bandLine, { x: -hw + bt * 0.9, y: -bt / 2 + bt * 0.14, width: hw * 2 - bt * 1.8, height: Math.max(0.8, bt * 0.12), rx: bt * 0.06 });
    attrs(this.bandShadow, { x: -hw * 0.96, y: -bt / 2 + 0.8 * s, width: hw * 1.92, height: bt, rx: bt / 2 });
    this.blur.setAttribute('stdDeviation', f(Math.max(2, 0.55 * s)));
    // stone shadow follows its outline, cast slightly toward the wrist
    attrs(this.stoneShadow, { d: outline(st.shape, L * 1.02, W * 1.02), transform: 'translate(' + f(0.35 * s) + ',' + f(0.9 * s) + ')' });
    var src = this.photos.stones[st.shape];
    this.fallback.innerHTML = '';
    if (src) {
      if (this.shape !== st.shape) { this.stoneImg.setAttribute('href', src); this.shape = st.shape; }
      attrs(this.stoneImg, { x: -W / 2, y: -L / 2, width: W, height: L, visibility: 'visible' });
    } else {
      // no photo for this shape yet: the drawn stone, at the same true size
      this.stoneImg.setAttribute('visibility', 'hidden'); this.shape = null;
      var fg = el('g', { transform: 'scale(' + f(s) + ')' }, this.fallback);
      stone(fg, st.shape, st.carat, 0, 0, {});
    }
    // prongs in the chosen metal
    this.prongs.innerHTML = '';
    var pr = Math.max(0.42, d.W * 0.07) * s, self = this;
    prongs(st.shape, L, W).forEach(function (p) {
      el('circle', { cx: f(p[0] + pr * 0.15), cy: f(p[1] + pr * 0.35), r: f(pr), fill: 'rgba(40,24,12,.35)' }, self.prongs);
      el('circle', { cx: f(p[0]), cy: f(p[1]), r: f(pr), fill: 'url(#' + id + 'p-' + metal + ')' }, self.prongs);
    });
    return { D: D };
  };
  // switch between the whole hand and the ring close-up, easing the viewBox
  PhotoScene.prototype.setZoom = function (on) {
    var from = this.vb.slice(), to = (on ? HAND.zoom : HAND.whole).slice(), svg = this.svg, self = this;
    if (this.raf) cancelAnimationFrame(this.raf);
    if (reduceMotion) { this.vb = to; svg.setAttribute('viewBox', to.join(' ')); return; }
    var t0 = performance.now(), dur = 520;
    (function step(now) {
      var t = Math.min(1, (now - t0) / dur), e = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      self.vb = from.map(function (v, i) { return v + (to[i] - v) * e; });
      svg.setAttribute('viewBox', self.vb.map(f).join(' '));
      if (t < 1) self.raf = requestAnimationFrame(step);
    })(t0);
  };
  function attrs(n, a) { for (var k in a) n.setAttribute(k, typeof a[k] === 'number' ? f(a[k]) : a[k]); }

  function drawCompare(st) {
    var list = COMPARE.slice();
    if (list.indexOf(st.carat) === -1) list.push(st.carat);
    list.sort(function (a, b) { return a - b; });
    var gap = 3.2, sizes = list.map(function (c) { return dims(st.shape, c); });
    var total = sizes.reduce(function (s, d) { return s + d.W; }, 0) + gap * (list.length - 1);
    var maxL = Math.max.apply(null, sizes.map(function (d) { return d.L; }));
    var pad = 2, H = maxL + 9;
    var svg = svgRoot(f(-pad) + ' ' + f(-maxL - 1) + ' ' + f(total + pad * 2) + ' ' + f(H + 1), '');
    var x = 0;
    list.forEach(function (c, i) {
      var d = sizes[i], cur = c === st.carat;
      if (st.photos && st.photos.stones[st.shape]) {
        el('path', { d: outline(st.shape, d.L, d.W), transform: 'translate(' + f(x + d.W / 2 + 0.12) + ',' + f(-d.L / 2 + 0.3) + ')', fill: 'rgba(40,24,12,.18)', filter: 'url(#dsBlur)' }, svg);
        el('image', { href: st.photos.stones[st.shape], x: f(x), y: f(-d.L), width: f(d.W), height: f(d.L), preserveAspectRatio: 'none' }, svg);
      } else {
        stone(svg, st.shape, c, x + d.W / 2, -d.L / 2, {});
      }
      if (cur) el('path', { d: outline(st.shape, d.L + 1.1, d.W + 1.1), transform: 'translate(' + f(x + d.W / 2) + ',' + f(-d.L / 2) + ')', fill: 'none', stroke: '#b8924f', 'stroke-width': '.28', 'stroke-dasharray': '.7 .5' }, svg);
      var t = el('text', { x: f(x + d.W / 2), y: '3.2', 'text-anchor': 'middle', 'font-size': '1.55', fill: cur ? '#9a7434' : 'currentColor', 'font-weight': cur ? '600' : '400' }, svg);
      t.textContent = c.toFixed(2) + ' ct';
      var t2 = el('text', { x: f(x + d.W / 2), y: '5.4', 'text-anchor': 'middle', 'font-size': '1.25', fill: 'currentColor', opacity: '.6' }, svg);
      t2.textContent = (Math.abs(d.L - d.W) < 0.05 ? d.W.toFixed(1) : d.L.toFixed(1) + ' × ' + d.W.toFixed(1)) + ' mm';
      x += d.W + gap;
    });
    return { svg: svg };
  }

  function icon(shape) {
    var d = SHAPES[shape], s = 9 / Math.max(d.L, d.W);
    var svg = el('svg', { viewBox: '-6 -6 12 12', 'aria-hidden': 'true', class: 'ds__shape-icon' });
    el('path', { d: outline(shape, d.L * s, d.W * s), fill: 'none', stroke: 'currentColor', 'stroke-width': '.7' }, svg);
    return svg;
  }

  function init(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';
    var labels = {};
    try { labels = JSON.parse(root.getAttribute('data-labels') || '{}'); } catch (e) {}
    var st = {
      view: 'hand',
      shape: SHAPES[root.dataset.shape] ? root.dataset.shape : 'round',
      carat: parseFloat(root.dataset.carat) || 1,
      size: parseInt(root.dataset.size, 10) || 6,
      metal: METALS[root.dataset.metal] ? root.dataset.metal : 'yellow'
    };
    try {
      var ph = JSON.parse(root.getAttribute('data-photos') || 'null');
      if (ph && ph.hand) {
        st.photos = { hand: ph.hand, stones: ph.stones || {} };
        // warm the cache so switching shape never shows an empty setting
        Object.keys(st.photos.stones).forEach(function (k, i) { setTimeout(function () { var im = new Image(); im.src = st.photos.stones[k]; }, i === 0 ? 0 : 600 + i * 150); });
      }
    } catch (e) {}
    var scene = null, zoomBtn = root.querySelector('[data-ds-zoom]');
    st.zoom = false;
    function zoomLabel() {
      if (!zoomBtn) return;
      zoomBtn.setAttribute('aria-pressed', st.zoom ? 'true' : 'false');
      var t = st.zoom ? (labels.zoom_out || 'Show the whole hand') : (labels.zoom_in || 'Zoom to the ring');
      zoomBtn.setAttribute('aria-label', t); zoomBtn.setAttribute('title', t);
      var tx = zoomBtn.querySelector('[data-ds-zoom-text]'); if (tx) tx.textContent = t;
    }
    if (zoomBtn) {
      zoomLabel();
      zoomBtn.addEventListener('click', function () { st.zoom = !st.zoom; zoomLabel(); if (scene) scene.setZoom(st.zoom); });
    }
    var min = parseFloat(root.dataset.min) || 0.25, max = parseFloat(root.dataset.max) || 5;
    if (min >= max) { min = 0.25; max = 5; }
    st.carat = Math.min(max, Math.max(min, st.carat));
    var canvas = root.querySelector('[data-ds-canvas]'), readout = root.querySelector('[data-ds-readout]'), dimsEl = root.querySelector('[data-ds-dims]');
    var range = root.querySelector('[data-ds-carat]'), out = root.querySelector('[data-ds-carat-out]');
    var sizeSel = root.querySelector('[data-ds-size]'), shapesWrap = root.querySelector('[data-ds-shapes]');
    var name = function (s) { return (labels.shapes && labels.shapes[s]) || s.charAt(0).toUpperCase() + s.slice(1); };

    // shape chips
    var group = 'ds-shape-' + Math.random().toString(36).slice(2, 7);
    ORDER.forEach(function (s) {
      var lab = document.createElement('label');
      lab.className = 'ds__shape';
      var inp = document.createElement('input');
      inp.type = 'radio'; inp.name = group; inp.value = s; inp.checked = s === st.shape;
      inp.addEventListener('change', function () { st.shape = s; render(); });
      var span = document.createElement('span');
      span.appendChild(icon(s));
      span.appendChild(document.createTextNode(name(s)));
      lab.appendChild(inp); lab.appendChild(span);
      shapesWrap.appendChild(lab);
    });
    // carat slider
    range.min = min; range.max = max; range.value = st.carat;
    root.querySelector('[data-ds-min]').textContent = min + ' ct';
    root.querySelector('[data-ds-mid]').textContent = (Math.round((min + max) / 2 * 4) / 4) + ' ct';
    root.querySelector('[data-ds-max]').textContent = max + ' ct';
    range.addEventListener('input', function () { st.carat = Math.round(parseFloat(range.value) * 100) / 100; render(); });
    // ring size
    Object.keys(RING).forEach(function (k) {
      var o = document.createElement('option');
      o.value = k; o.textContent = k + ' (' + RING[k].toFixed(1) + ' mm)';
      if (+k === st.size) o.selected = true;
      sizeSel.appendChild(o);
    });
    sizeSel.addEventListener('change', function () { st.size = parseInt(sizeSel.value, 10); render(); });
    // metal
    root.querySelectorAll('[data-ds-metal]').forEach(function (r) {
      r.checked = r.value === st.metal;
      r.addEventListener('change', function () { if (r.checked) { st.metal = r.value; render(); } });
    });
    // views
    var tabs = root.querySelectorAll('[data-ds-view]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        st.view = t.dataset.dsView;
        tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        render();
      });
    });

    function render() {
      out.textContent = st.carat.toFixed(2) + ' ct';
      range.style.setProperty('--p', ((st.carat - min) / (max - min) * 100).toFixed(1) + '%');
      root.classList.toggle('is-compare', st.view === 'compare');
      var d = dims(st.shape, st.carat), res;
      root.classList.toggle('is-photo', !!st.photos && st.view === 'hand');
      if (st.view === 'hand' && st.photos) {
        if (!scene) scene = new PhotoScene(st.photos);
        if (scene.svg.parentNode !== canvas) { canvas.innerHTML = ''; canvas.appendChild(scene.svg); }
        res = scene.update(st);
        dimsEl.textContent = (labels.dims_hand || 'Approx. {L} × {W} mm face-up · on a size {S} finger ({D} mm)')
          .replace('{L}', d.L.toFixed(1)).replace('{W}', d.W.toFixed(1)).replace('{S}', st.size).replace('{D}', res.D.toFixed(1));
      } else if (st.view === 'hand') {
        canvas.innerHTML = '';
        res = drawHand(st);
        canvas.appendChild(res.svg);
        dimsEl.textContent = (labels.dims_hand || 'Approx. {L} × {W} mm face-up · on a size {S} finger ({D} mm)')
          .replace('{L}', d.L.toFixed(1)).replace('{W}', d.W.toFixed(1)).replace('{S}', st.size).replace('{D}', res.D.toFixed(1));
      } else {
        canvas.innerHTML = '';
        res = drawCompare(st);
        canvas.appendChild(res.svg);
        dimsEl.textContent = (labels.dims_compare || 'Shown to scale with each other. Approx. {L} × {W} mm at {C} ct.')
          .replace('{L}', d.L.toFixed(1)).replace('{W}', d.W.toFixed(1)).replace('{C}', st.carat.toFixed(2));
      }
      readout.textContent = name(st.shape) + ' · ' + st.carat.toFixed(2) + ' ' + (labels.carats || 'carats');
    }
    render();
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-diamond-size]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  window.FzDiamondSize = { dims: dims, SHAPES: SHAPES, RING: RING };
})();
